// extracted by mini-css-extract-plugin
export default {"popupBody":"LoginAlert_popupBody__HRQ2F","closeBtn":"LoginAlert_closeBtn__8L0YT"};